import { Route, Routes } from "react-router-dom";
import Home from "../../pages/Home";
import SignIn from "../../pages/SignIn";
import Register from "../../pages/Register";
import ProtectedLayout from "../../layouts/ProtectedLayout";
import Dashboard from "../../pages/Dashboard";
import Profile from "../../pages/Profile";
import InviteUser from "../../pages/InviteUser";
import Downline from "../../pages/Downline";
import Transactions from "../../pages/Transactions";
import Passbook from "../../pages/Passbook";
import Commissions from "../../pages/Commissions";
import Payins from "../../pages/Payins";
import Payouts from "../../pages/Payouts";
import PayBills from "../../pages/PayBills";
import Cards from "../../pages/Cards";
import FinkedaPay from "../../pages/FinkedaPay";
import FinkedaTransactions from "../../pages/FinkedaTransactions";
import FinkedaAdminConfig from "../../pages/FinkedaAdminConfig";
import PaymentCallback from "../../pages/PaymentCallback";
import Maintenance from "../../pages/Maintenance";
import PayOffline from "../../pages/PayOffline";

export default function HomeRoutes() {
    return (
        <Routes>
            {/* Public marketing home page. Signed-in users can still reach the
                dashboard from the header; "/" is no longer an auth redirect. */}
            <Route index element={<Home />} />
            <Route path="signin" element={<SignIn />} />
            <Route path="register" element={<Register />} />
            <Route path="maintenance" element={<Maintenance />} />

            <Route element={<ProtectedLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="invite" element={<InviteUser />} />
                <Route path="downline" element={<Downline />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="passbook" element={<Passbook />} />
                <Route path="commissions" element={<Commissions />} />
                <Route path="payins" element={<Payins />} />
                <Route path="pos-qr" element={<PayOffline />} />
                <Route path="pay-bills" element={<PayBills />} />
                <Route path="cards" element={<Cards />} />
                <Route path="payouts" element={<Payouts />} />
                <Route path="finkeda" element={<FinkedaPay />} />
                <Route
                    path="finkeda/transactions"
                    element={<FinkedaTransactions />}
                />
                <Route
                    path="finkeda/config"
                    element={<FinkedaAdminConfig />}
                />
                <Route path="payment/callback" element={<PaymentCallback />} />
            </Route>
        </Routes>
    );
}
